import type { FunctionComponent, ReactNode } from 'react'

import { useMediaQuery, useTheme } from '@material-ui/core'
import { FlowPage } from '@monthio/design-system'
import { HomeBudget } from '@monthio/icons'
import { BodyFlow, FlowContainer, Icons } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import type { StepComponent } from './steps'

import { ParingChoiceSelector } from '../../GenericLandingPage/ParingChoiceSelector'
import {
	ContentWrapper,
	H2WithoutMargin,
	IconAndItemWrapper,
	ListWrapper,
} from '../budgetHelperLandingPageStyles'

const IconWrapper = styled.div`
	text-align: center;
`

const ListItem: FunctionComponent<{
	children: ReactNode
}> = ({ children }) => {
	return (
		<IconAndItemWrapper>
			<Icons.CheckCircleIcon fontSize={24} />
			<BodyFlow>{children}</BodyFlow>
		</IconAndItemWrapper>
	)
}

export const BudgetFlowStartLandingPage: StepComponent = ({ formProps }) => {
	const { t } = useTranslation()
	const isLarge = useMediaQuery(useTheme().breakpoints.up('sm'))

	return (
		<FlowPage.Content $spacing="l">
			<IconWrapper>
				<HomeBudget width={isLarge ? 160 : 87} height={isLarge ? 160 : 87} />
			</IconWrapper>
			<FlowPage.Header
				title={t('budgetHelper-budgetLandingPage-title')}
				description={t('budgetHelper-budgetLandingPage-subtitle')}
			/>
			<H2WithoutMargin>
				{t('budgetHelper-budgetLandingPage-dataProtection-title')}
			</H2WithoutMargin>
			<ListWrapper>
				{[...Array(4).keys()].map((i) => (
					<ListItem key={`DATA_PROTECTION::${i}`}>
						{t(`budgetHelper-budgetLandingPage-dataProtection-item${i}`)}
					</ListItem>
				))}
			</ListWrapper>
			<ParingChoiceSelector clientInputs={formProps.values} />
		</FlowPage.Content>
	)
}
